import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../../assets/css/authenticationStyles.css';
import notap_logo from '../../../assets/images/notap_logo.png';
import {
  clearAll
} from "../../../config/redux/slice/authSlice";
import { appUrls } from '../../../utils/urls/appUrls';

export default function ProfileCompletionSuccess() {
  const dispatch = useDispatch()

  const {
        token,
        loading,
        errorMsg,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

  useEffect(()=>{
      dispatch(clearAll({}))
    }, [])  


  return (
    <div className='d-flex justify-content-center align-items-baseline profile-creation'>
      <div style={{marginTop: '4rem'}} className='card card-default pt-5 px-5 pb-0'>
        <div className='formContainer'>
            <div style={{columnGap: '1rem'}} className='d-flex align-items-center justify-content-center'>
              <img src={notap_logo} alt='logo' className='logotypeImage' />
              <h2 className='font-weight-bold'>
                NOTAP Portal
              </h2>              
            </div>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
                <i style={{fontSize: '1.5rem'}} className={`text-success mdi mdi-checkbox-marked-circle`}></i>
              <p style={{fontSize: '1.3rem'}} className={`text-success text-capitalize`}>
                Profile Creation Complete
              </p>
            </div>
            <form className='mainForm'>
              <div className="row w-100 m-0">
                <div className='text-center mb-5' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>You have successfully completed the creation of your profile.</p>
        </div>
      <div className="col-md-12">


        <button type="button" className="btn btn-outline-primary mb-4">
            <i className=" mdi mdi-arrow-left-thick mr-1"></i>
            {user_role == 'BANK_USER' ?
            <Link className='text-hover-white' to={appUrls.bank_certificates}>Proceed to Dashboard</Link> :
            <Link className='text-hover-white' to={appUrls.certificates}>Proceed to Dashboard</Link>}
        </button>
        {/* <Spinner/> */}
      </div>
              </div>
            </form>
        </div>        
      </div>        
    </div>
  )
}
